import { RectangleGroupIcon } from '@heroicons/react/24/outline'
import { vehicleTypeOptions } from './constants/statusOptions'
import { SearchQuery } from './filter/SearchQuery'
import { SelectFilter } from './filter/SelectFilter'
import { useVehicleFilters } from './hooks/useVehicleFilters'
import { SelectionSummary } from './SelectionSummary'

export const FiltersRow = () => {
  // Use the nuqs-based filter hook
  const {
    filters,
    updateSearch,
    updateType,
    clearAllFilters,
    hasActiveFilters,
  } = useVehicleFilters()

  const handleClearFilters = () => {
    // Clear nuqs filters
    clearAllFilters()
  }

  // Check if any filters are active - now only using nuqs filters
  const hasAnyActiveFilters = hasActiveFilters

  return (
    <div className="mb-2">
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <SearchQuery
            onSearchChange={updateSearch}
            placeholder="Buscar vehículo..."
            searchQuery={filters.search}
          />

          <SelectFilter
            activeSelections={filters.type}
            icon={<RectangleGroupIcon className="h-4 w-4" />}
            onSelectionsChange={updateType}
            placeholder="Buscar tipo..."
            searchActive={false}
            selectionOptions={vehicleTypeOptions}
            title="Tipo"
          />
        </div>

        {hasAnyActiveFilters && (
          <SelectionSummary
            // Active nuqs filters
            handleClearFilters={handleClearFilters}
            searchQuery={filters.search}
            setSearchQuery={updateSearch}
            setType={updateType}
            type={filters.type}
            typeOptions={vehicleTypeOptions}
          />
        )}
      </div>
    </div>
  )
}
